import { render } from "./payslip-report-table.vue?vue&type=template&id=17bdb72b"
import script from "./payslip-report-table.vue?vue&type=script&lang=js"
export * from "./payslip-report-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__